import { render, staticRenderFns } from "./departmentManage.vue?vue&type=template&id=425e130c"
import script from "./departmentManage.vue?vue&type=script&lang=js"
export * from "./departmentManage.vue?vue&type=script&lang=js"
import style0 from "./departmentManage.vue?vue&type=style&index=0&id=425e130c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports